if(!customElements.get('swym-wishlist-page')){
    class SwymWishlistPage extends HTMLElement{
        constructor(){
            super();
            document.addEventListener('swym:default-list-executed', this._initializeSwymComponent.bind(this));
        }

        _init(swat){
            this._initializeSelectors(swat);
            this.isShareWishlistPage ? this._renderShareWishlist(swat) : this._renderWishlist(swat);
            this._attachEventListeners();
        }

        /* General funcions */

        _initializeSwymComponent(){
            if (!window.SwymCallbacks) window.SwymCallbacks = [];
            window.SwymCallbacks.push(this._init.bind(this));
        }

        async _initializeSelectors (swat){
            this.lists = [];
            this.swat = swat;
            this.body = document.body;
            this.settings = JSON.parse(this.dataset.settings);
            this.isShareWishlistPage = window.isShareListPage;
            // this.isSingleList = !swat.retailerSettings.Wishlist.EnableCollections;
            this.isShareEnabledUsingSocialMedia = swat.retailerSettings.Wishlist.AllowSharing;
            this.isSFLEnabled = swat.retailerSettings.SFL.SFLFeatureEnabled;

            /* Page Header Selectors */ 

            this.accountButton = this.querySelector('#swymcs-user-login-status-btn');
            this.accountPopup = this.querySelector('#swymcs-user-login-status-popup');
            this.accountPopupCloseButton = this.querySelector('#swymcs-close-account-popup');
            this.accountPopupCancelButton = this.querySelector('#swymcs-cancel-account-popup');
            this.accountPopupActionButton = this.querySelector('#swymcs-account-login-action-button');
            this.listSenderName = this.querySelector('#swymcs-lists-share-sender-details-name-value'); 
            this.listSenderEmail = this.querySelector('#swymcs-lists-share-sender-details-email-value');
            this.listSenderTier = this.querySelector('#swymcs-lists-share-sender-details-tier-value');
            this.pageTitleTabContainer = this.querySelector('#swymcs-title-wrapper');
            this.pageTitleWishlistTab = this.querySelector('#swymcs-page-title');
            this.pageTitleSFLTab = this.querySelector('#swymcs-sfl-page-title');

            /* Wishlist grid container */
            this.emptyListContainer = this.querySelector('#swym-empty-wishlist-container'); 
            this.emptySFLListContainer = this.querySelector('#swym-empty-sfl-list-container'); 
            this.wishlistContainer = this.querySelector('#swymcs-wishlist-container');
            this.listsContainer = this.querySelector('#swymcs-lists-grid');
            this.listProductsContainer = this.querySelector('#swymcs-products-grid-container');
            this.productsContainer = this.querySelector('#swymcs-products-grid');
            this.wishlistHeader = this.querySelector('#swymcs-wishlist-header');
            this.backToListView = this.querySelector('#swymcs-back-to-lists-view');
            this.pageLoader = this.querySelector("#swymcs-loader-container");

            /* Lists header selectors */
            this.activeListContainer = this.querySelector('#swymcs-active-list');
            this.activeListImage = this.querySelector('#swymcs-active-list-image');
            this.activeListImageText = this.querySelector('#swymcs-active-list-image-text');
            this.activeListTilte = this.querySelector('#swymcs-active-list-title');
            this.activeListItemCount = this.querySelector('#swymcs-active-list-item-count');
            this.headerListsContainer = this.querySelector('#swymcs-header-lists');

            /* Additional Options selectors */ 

            this.additionalOptionsContainer = this.querySelector('#swymcs-additional-options');
            this.additionalOptionsBtn = this.querySelector('#swymcs-view-additional-options');
            this.shareListButton = this.querySelector('#swymcs-share-list');
            this.renameListButton = this.querySelector('#swymcs-rename-list');
            this.duplicateListButton = this.querySelector('#swymcs-duplicate-list');
            this.deleteListButton = this.querySelector('#swymcs-delete-list');

            /* Additional Options popup selectors */
            this.additionalOptionsPopupContainer = this.querySelector('#swymcs-additional-options-popup-container');
            this.additionalOptionsPopupCloseButton = this.querySelector('#swymcs-close-additional-popup');
            this.additionalPopupCancelButtons = this.querySelectorAll('.swymcs-additonal-popup-cancel-button');

                /* Share List popup selectors */ 
                this.shareListPopup = this.querySelector('#swymcs-share-list-popup');
                this.shareLinkField = this.querySelector('#swymcs-share-link-field');
                this.shareNameField = this.querySelector('#swymcs-share-name-field');
                this.shareEmailField = this.querySelector('#swymcs-share-email-field');
                this.shareMessageField = this.querySelector('#swymcs-share-message-field');
                this.shareListError = this.querySelector('#swymcs-share-email-field-error');
                this.emailShareButton = this.querySelector('#swymcs-confirm-share-list');
                this.additionalShareButtonsContainer = this.querySelector('.swymcs-additional-share-buttons-container');
                this.copyLinkButton = this.querySelector('#swymcs-confirm-share-list--copy');
                this.facebookShareButton = this.querySelector('#swymcs-confirm-share-list--facebook');
                this.twitterShareButton = this.querySelector('#swymcs-confirm-share-list--twitter');
                
                /* Delete List popup selectors */ 
                this.deleteListPopup = this.querySelector('#swymcs-delete-list-popup');
                this.deleteListName = this.querySelector('#swymcs-confirm-delete-list-name');
                this.confirmDeleteListButton = this.querySelector('#swymcs-confirm-delete-list'); 
                
                /* Rename List popup selectors */ 
                this.renameListPopup = this.querySelector('#swymcs-rename-list-popup');
                this.renameListName = this.querySelector('#swymcs-confirm-rename-list-name');
                this.renameListError = this.querySelector('#swymcs-rename-list-error');
                this.renameListTextField = this.querySelector('#swymcs-rename-list-field')
                this.confirmRenameListButton = this.querySelector('#swymcs-confirm-rename-list'); 

                /* Duplicate List popup selectors */ 
                this.duplicateListPopup = this.querySelector('#swymcs-duplicate-list-popup');
                this.duplicateListName = this.querySelector('#swymcs-confirm-duplicate-list-name');
                this.duplicateListError = this.querySelector('#swymcs-duplicate-list-error');
                this.duplicateListTextField = this.querySelector('#swymcs-duplicate-list-field');
                this.confirmDuplicateListButton = this.querySelector('#swymcs-confirm-duplicate-list'); 

            this.recipeListProducts = await this._getArticlesData(window.recipeProducts);
            this.blogListProducts = await this._getArticlesData(window.blogProducts);
        }

        _attachEventListeners(){

            this.body.addEventListener('click', evt => this._overlayEvent(evt));

            /* Adding events to page header elements */ 

            this.accountButton.addEventListener('click', evt => this._showPopupContainer(this.accountPopup));
            this.accountPopupCloseButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupCancelButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupActionButton.addEventListener('click', this._loginButtonAction.bind(this));
            this.pageTitleTabContainer.addEventListener('click', this._toggleListView.bind(this));

            /* Header Lists Events */
            
            this.activeListContainer.addEventListener('click', evt => this._showPopupContainer(this.headerListsContainer));
            this.headerListsContainer.addEventListener('click', this._switchListsFromHeader);

            /* Additional Options Events */     
            this.additionalOptionsBtn.addEventListener('click', evt => this._showPopupContainer(this.additionalOptionsContainer));   
            this.additionalOptionsContainer.addEventListener('click', this._renderAdditionalOptionsPopup);
            this.shareListButton.addEventListener('click', this._renderShareListPopup.bind(this));

            /* Additional Options Popup Events */
            this.additionalPopupCancelButtons.forEach(btn => btn.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this)));
            this.additionalOptionsPopupCloseButton.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this));
             
                /* Share List Events */
                this.copyLinkButton.addEventListener('click', this._shareListByCopy.bind(this));
                this.emailShareButton.addEventListener('click', this._shareListByEmail.bind(this));
                this.facebookShareButton.addEventListener('click', evt => this._shareListOnPlatform('facebook'));
                this.twitterShareButton.addEventListener('click', evt => this._shareListOnPlatform('twitter'));
                this.shareEmailField.addEventListener('input', this._validateEmail.bind(this));

                /* Rename List Events */
                this.confirmRenameListButton.addEventListener('click', this._renameList.bind(this));
                this.renameListTextField.addEventListener('input', evt => this._validateListName(
                    this.renameListTextField.value.trim().toLowerCase(),
                    this.renameListError
                ))

                /* Duplicate List Events */
                this.confirmDuplicateListButton.addEventListener('click', this._duplicateList.bind(this));
                this.duplicateListTextField.addEventListener('input', evt => this._validateListName(
                    this.duplicateListTextField.value.trim().toLowerCase(),
                    this.duplicateListError
                ))

                /* Delete List Events */ 
                this.confirmDeleteListButton.addEventListener('click', this._deleteList.bind(this));

            /* Lists grid buttons */
            this.listsContainer.addEventListener('click', this._showListDetails);
            this.productsContainer.addEventListener('click', this._eventsForProductsGrid);
            this.productsContainer.addEventListener('change', this._selectProductSize.bind(this));
            this.backToListView.addEventListener('click', this._triggerBackToListView.bind(this));
        }

        async _triggerBackToListView(){
            this._renderMultipleList();
        }

        _showListDetails(evt){
            const target = evt.target;
            const page = document.querySelector('swym-wishlist-page');
            if(target.getAttribute('id') != 'swymcs-lists-grid'){
                const lid = evt.target.closest('.swymcs-list-item').dataset.lid;
                const action = target?.dataset?.action || 'view-list';
                if(target.classList.contains('swymcs-view-list-button') && action == 'shop')
                    location.href = '/';
                else 
                page._renderListProducts(lid);   
            } return;  
        }
        
        async _renderWishlist(){
            this.lists = await this._getCompleteListDetails();
            this._renderSingleList();
            this._renderSFLContents();
        }

        async _renderShareWishlist(){
            const lid = new URL(document.location).searchParams.get("lid");
            
            // Common UI updates
            const updateUI = (showHeader = true) => {
                this._showContainer(this.listProductsContainer);
                this._showContainer(this.wishlistContainer);
                this._hideContainer(this.pageLoader);
                this._hideContainer(this.backToListView);
            };

            if(!lid){
                this._renderProductsGrid([]);
                updateUI(false);
                return;
            }

            window.currentActiveListId = lid;
            const listType = lid == window.productListId ? 'wishlist' : lid == window.recipeListId ? 'recipe' : 'blog';
            await this._renderSharedListHeader(listType);
            try {
                if(listType == 'wishlist') {
                    const wishlistProducts = await this._getProductsFromList(lid);
                    this.listcontents = await this._getShopifyProductsData(wishlistProducts);
                    if(!this.listcontents || !this.listcontents.length){
                        this._renderEmptyList();
                        updateUI(false);
                        return;
                    }
                    this._renderProductsGrid(this.listcontents);
                    updateUI();
                } else if(listType == 'recipe' || listType == 'blog') {
                    const articles = await this._getProductsFromList(lid);
                    this.listcontents = await this._getArticlesData(articles);
                    if(!this.listcontents || !this.listcontents.length){
                        this._renderEmptyList();
                        updateUI(false);
                        return;
                    }
                    this._renderArticlesGrid(this.listcontents);
                    updateUI();
                }
            } catch (error) {
                console.error('Error fetching wishlist products:', error);
                this._renderEmptyList();
                updateUI(false);
            }
        }

        async _renderSingleList() {
            if (this.list && this.list.listcontents) {
                window.currentActiveListId = this.list.lid;
                await this._renderSingleListHeader(this.list.lid);
                this._hideContainer(this.pageLoader);
                this._showContainer(this.wishlistHeader);
                this._renderProductsGrid(this.list.listcontents);
                this._showContainer(this.wishlistContainer);
                this._showContainer(this.listProductsContainer);
                return;
            }

            this.lists = await this._getLists();
            if (!this.lists.length) {
                this._renderEmptyState();
                return;
            }
            this.list = this.lists.find(list => list.lname.toLowerCase() == 'my wishlist') || this.lists[0];
            window.currentActiveListId = this.list.lid;
            this.list.listcontents = await this._getProductsFromList(this.list.lid);
            this.list.listcontents = await this._getShopifyProductsData(this.list.listcontents);

            // Cache the list data
            this.list = this._setListProperties(this.list, this.list.listcontents, true);

            this._hideContainer(this.pageLoader);
            await this._renderSingleListHeader(this.list.lid);
            this._renderProductsGrid(this.list.listcontents);
            this._showContainer(this.wishlistContainer);
            this._showContainer(this.listProductsContainer);
        }

        _renderMultipleList() {
            if(!this.lists.length){
                this._renderEmptyState();
                return;
            }
            console.log(this.lists, 'this.lists');
            this._renderListsView();
            this.emptyListContainer.classList.add('swym-hide-container');
            this.wishlistContainer.classList.remove('swym-hide-container');
        }

        _renderEmptyState(){
            this._hideContainer(this.pageLoader);
            this.emptyListContainer.classList.remove('swym-hide-container');
            this.wishlistContainer.classList.add('swym-hide-container');
        }

        async _renderListsView(){
            window.currentActiveListId = '';
            const html = this.lists.map(list => {
                const productCount = list.totalProducts || 0;
                const buttonText = !productCount ? 'Continue Shopping' : 'View List';
                const buttonAction = !productCount ? 'shop' : 'view-list';
                
                const imageHtml = this._generateListPreviewImages(list);
                
                return `
                    <button class="swymcs-button swymcs-list-item swymcs-wishlist-grid-item" 
                            data-lid="${list.lid}" 
                            aria-label="View list ${list.lname}" 
                            id="list--${list.lid}">
                        <div class="swymcs-list-title-container">
                            <div class="swymcs-list-title">${list.lname}</div>
                            <div class="swymcs-list-product-count-container">
                                <span class="swymcs-product-count">${productCount}</span>
                                <span class="swymcs-product-count-text">${productCount > 1 ? 'products' : 'product'}</span>
                            </div>
                        </div>
                        ${imageHtml}
                        <div class="swymcs-view-list-button swymcs-major-button" 
                             data-action="${buttonAction}" 
                             id="swymcs-view-list-button-${list.lid}" 
                             aria-label="${buttonText}">
                            ${buttonText}
                        </div>
                    </button>
                `;
            }).join('');

            this.listsContainer.innerHTML = html;
            this._showContainer(this.listsContainer);
            this._hideContainer(this.listProductsContainer);
            this._hideContainer(this.pageLoader);
            this._scrollToTop();
        }

        _generateListPreviewImages(list) {
            const listContents = list?.listcontents || [];
            let imageHtml = `<div class="swymcs-list-image-container">`;
            
            if(listContents.length) {
                for(let i = 0; i < 3; i++) {
                    if(listContents[i]) {
                        const product = listContents[i].productData;
                        const selectedVariant = product.variants.find(variant => variant.id === listContents[i].epi);
                        const imageSrc = selectedVariant?.featured_image?.src || product?.featured_image ||  listContents[i].iu;
                        imageHtml += `
                            <div class="swymcs-wishlist-image-wrapper">
                                <img src="${imageSrc}" 
                                     alt="${listContents[i].productData.title}" 
                                     class="swymcs-wishlist-image"/>
                            </div>`;
                    }
                }
                imageHtml += '</div>';
            } else {
                imageHtml += `<p class="swymcs-no-products-message">This is an empty list!</p></div>`;
            }
            
            return imageHtml;
        }

        async _renderListProducts(lid){
            this._hideContainer(this.listsContainer);
            this._showContainer(this.pageLoader);
            this._showContainer(this.wishlistHeader);
            this._showContainer(this.backToListView);
            this._showContainer(this.activeListContainer);
            window.currentActiveListId = lid;
            
            const selectedList = this.lists.find(list => list.lid == lid);
            if(!selectedList.allProductsLoaded) {
                // Load all products only when viewing full list
                const allProducts = await this._getProductsFromList(lid);
                selectedList.listcontents = selectedList.lid == window.productListId ? await this._getShopifyProductsData(allProducts) : allProducts;
                selectedList.allProductsLoaded = true;
            }
            
            this._renderListHeader(lid);
            this._hideContainer(this.pageLoader);
            this._renderProductsGrid(selectedList.listcontents);
            this._showContainer(this.listProductsContainer);
        }

        async _renderSharedListHeader(type){
            this.activeListContainer.style.pointerEvents = 'none';
            this._hideContainer(this.additionalOptionsBtn);
            this._hideContainer(this.shareListButton);
            this._hideContainer(this.wishlistHeader);
            this._showContainer(this.pageTitleTabContainer);
            this.querySelectorAll('.swymcs-page-title').forEach(tab => tab.hasAttribute('data-type') && tab.getAttribute('data-type') != type ? tab.classList.add('swym-hide-container') : tab.classList.remove('swym-hide-container'));
        }

        async _renderSingleListHeader(lid){
            this._renderActiveList(this.list);
            this.activeListContainer.style.pointerEvents = 'none';
            this._showContainer(this.additionalOptionsBtn);
            this._hideContainer(this.backToListView);
            this._hideContainer(this.pageLoader);
            this._hideContainer(this.renameListButton);
            this._hideContainer(this.duplicateListButton);
        }

        async _renderArticlesHeader(articleType){
            this._renderActiveArticlesList(articleType);
            this.activeListContainer.style.pointerEvents = 'none';
            this._showContainer(this.additionalOptionsBtn);
            this._hideContainer(this.backToListView);
            this._hideContainer(this.pageLoader);
            this._hideContainer(this.renameListButton);
            this._hideContainer(this.duplicateListButton);
        }

        _renderListHeader(lid){
            const lists = this.lists; 
            const activeList = lists.find(list => list.lid == lid);
            this._renderActiveList(activeList);
            let html = ``;
            lists.forEach((list, index) => {
                const listContents = list?.listcontents || [];
                if(listContents.length){
                    const product = listContents[0].productData;
                    const selectedVariant = product.variants.find(variant => variant.id === listContents[0].epi);
                    const imageSrc = selectedVariant?.featured_image?.src || product?.featured_image || listContents[0].iu;
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <img src="${imageSrc}" alt="${list.lname}"/>
                        <span class="swym-list-item">${list.lname} (${listContents.length})</span>
                    </li>`
                }else {
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <span class="swymcs-list-item-image-text">${list.lname[0]}</span>
                        <span class="swymcs-list-item">${list.lname} (0)</span>
                    </li>`
                }
            })
            this.headerListsContainer.innerHTML = html;
        }

        _renderActiveList(list){
            const listContent = list?.listcontents || [];
            this.activeListTilte.textContent = list.lname;
            this.activeListItemCount.textContent = `(${listContent.length})`;
            if(listContent.length){
                this.activeListImage.src = listContent[0].iu;
                this.activeListImage.alt = listContent[0].lname;
                this._hideContainer(this.activeListImageText);
                this._showContainer(this.activeListImage);
            }else {
                this.activeListImageText.textContent = list.lname[0];
                this.activeListImage.alt = listContent.lname;
                this._hideContainer(this.activeListImage);
                this._showContainer(this.activeListImageText);
            }
        }

        _renderActiveArticlesList(articleType){
            const listTitle = articleType == 'recipe' ? window.recipeListTitle : window.blogListTitle;
            const listId = articleType == 'recipe' ? window.recipeListId : window.blogListId;
            const articles = articleType == 'recipe' ? this.recipeListProducts : this.blogListProducts;
            window.currentActiveListId = listId;
            this.activeListTilte.textContent = listTitle;
            this.activeListItemCount.textContent = `(${articles.length})`;
            if(articles.length){
                this.activeListImage.src = articles[0].articlesData.image;
                this.activeListImage.alt = articles[0].articlesData.title;
                this._hideContainer(this.activeListImageText);
                this._showContainer(this.activeListImage);
            }else {
                this.activeListImageText.textContent = listTitle[0];
                this.activeListImage.alt = listTitle;
                this._hideContainer(this.activeListImage);
                this._showContainer(this.activeListImageText);
            }
        }

        _renderProductsGrid(shopifyProducts, type = 'wishlist'){
            if(!shopifyProducts.length) {
                if(type == 'sfl') this._renderEmptySFLList();
                else this._renderEmptyList();
                return;
            }
            let productMarkup = ``;
            shopifyProducts.forEach(async (pdp, index) => {
                if(!pdp) return;
                const product = pdp.productData;
                const selectedVariant = product.variants.find(variant => variant.id === pdp.epi);
                const selectedVariantTitle = selectedVariant.title && selectedVariant.title.toLowerCase() != 'default title' ? selectedVariant.title : '';
                const selectedVariantPrice = parseFloat(selectedVariant.price/100.00).toFixed(2);
                const selectedVariantCompareAtPrice = selectedVariant.compare_at_price > 0 && selectedVariant.compare_at_price != selectedVariant.price ? parseFloat(selectedVariant.compare_at_price/100.00).toFixed(2) : 0;
                const labelText = product.metafieldData != 'NA' ? product.metafieldData : '';
                let addToCartBtnText = selectedVariant.available ? (_swat.platform.isInDeviceCart(selectedVariant.id) ? `${this.settings.added_to_cart_text}` : `${this.settings.add_to_cart_text}`) : `${this.settings.sold_out_text}`;
                const inCart = _swat.platform.isInDeviceCart(selectedVariant.id) ? 'swymcs-product-in-cart' : '';
                const lid = pdp.lid;
                let isSoldOut = !selectedVariant.available ? 'swymcs-sold-out' : '';
                let isButtonDisabled = isSoldOut ? 'disabled': '';
                const imageSrc = selectedVariant?.featured_image?.src || product?.featured_image ||  pdp.iu; 
                const productUrl = pdp?.product?.du || pdp.du;
                let variantSelector=`<select class="!rounded-[0.375rem] border-y border-r border-l border-t-border text-utility-regular" data-purpose="select" id="swym-size-selector--${index}" class="${!selectedVariant.available ? 'swym-strikethrough' :''}">`;
                if(product.variants.length > 1){
                    product.variants.forEach(variant =>{
                        variantSelector+=`
                            <option ${variant.available ? '' : 'disabled="true"'} value="${variant.id}" ${variant.id === selectedVariant.id ? 'selected' : ''} data-available=${variant.available} data-variant-cost=${parseFloat(variant.price/100.00).toFixed(2)} data-incart=${_swat.platform.isInDeviceCart(variant.id)}>${variant.title}</option>
                        `
                    })
                }
                variantSelector+=`</select>`;
               productMarkup += `
                <div data-url="${productUrl}" data-lid="${lid}" data-epi="${selectedVariant.id}" data-empi="${product.id}" data-du="${pdp.du}" class="swymcs-product-card" id="wishlist-grid-item--${index}">
                    <div class="w-full group relative flex flex-col overflow-hidden bg-white product-card h-full">
                        <div class="block relative group">
                            <a href="${productUrl}" class="block overflow-clip aspect-square">
                                <img src="${imageSrc}" alt="${product.title}" class="w-full block h-full w-full object-cover object-center object-cover" loading="lazy"/>
                            </a>
                            <button data-list-type="${type}" data-lid="${lid}" data-purpose="delete" data-epi="${selectedVariant.id}" data-empi="${product.id}" data-du="${pdp.du}" class="swymcs-has-after-css ${this.isShareWishlistPage && 'swym-hide-container'} !bg-p-lightest !text-t-foreground !top-2 !right-2 !absolute !size-[1.625rem] !rounded-full !flex !items-center !justify-center swymcs-button swymcs-product-delete-btn" aria-label="Delete ${product.title}">
                                <span class="swym-icon">${this.settings.swym_delete_list_icon}</span>
                            </button>
                            <div class="swymcs-add-to-cart-btn-container absolute hidden md:block bottom-xs left-xs right-xs z-1 group-hover:opacity-100 opacity-0 transition-opacity duration-300 ease-in-out">
                                <button ${isButtonDisabled} variant="primary" data-purpose="cart" data-du="${pdp.du}" data-epi="${selectedVariant.id}" data-empi="${product.id}" 
                                    class="${inCart} ${isSoldOut} btn w-full !h-8 swymcs-add-to-cart-btn" aria-label="${addToCartBtnText}">
                                    ${addToCartBtnText}
                                </button>
                            </div>
                        </div>
                        <div class="flex flex-col flex-1 pt-2.5 gap-2xs">
                            <h3 class="product-card-title text-heading-6 font-medium leading-[1.2]">
                                <a href="${productUrl}" class="line-clamp-2">
                                    ${product.title}
                                </a>
                                <div class="swymcs-variant-selector-container">
                                ${product.variants.length > 1 ? variantSelector : ''}
                                    <div class="swymcs-price-container inline-flex gap-x-xs justify-start items-center group/price text-utility-regular on-sale">
                                        <div class="hidden group-[.on-sale]/price:flex items-center gap-[5px] flex-wrap product-card-price">
                                            <span class="text-utility-regular text-t-accent-01">
                                                ${window.currencyCode}${selectedVariantPrice}
                                            </span>
                                            ${selectedVariantCompareAtPrice > 0 ? `
                                                <span class="sr-only">Regular price</span>
                                                <span>
                                                    <s class="caption line-through text-t-disabled">
                                                        ${window.currencyCode}${selectedVariantCompareAtPrice}
                                                    </s>
                                                </span>
                                            ` : ``}
                                        </div>
                                    </div>
                                </div>
                            </h3>
                        </div>
                    </div>
                </div>
               `;
            });
            this.productsContainer.innerHTML = productMarkup;
            this.productsContainer.classList.remove('swymcs-empty-list');
            this._scrollToTop();
        }

        async _getArticlesData(articles){
            let response = await Promise.all(articles.map(async (article) => {
                const sectionHtml=await(await fetch(`${article.du}?section_id=swymcs-articles`)).text();
                const articlesDataHTML = new DOMParser().parseFromString(sectionHtml,"text/html").getElementById("swymcs-articles").textContent;
                const articlesData = await JSON.parse(articlesDataHTML);
                article.articlesData = articlesData.title ? articlesData : null;
                return article;
            }));
            
            console.log('Articles with bugs - ', response.filter(article => !article || !article.articlesData || !article.articlesData.title));
            return response.filter(article => article && article.articlesData);
        }

        async _renderArticlesGrid(articles, type = 'wishlist'){
            if(!articles.length) {
                this._renderEmptyList();
                return;
            }
            let articleMarkup = ``;
            articles.forEach(async (article, index) => {
                const articlesData = article.articlesData;
                const articleType = article.lid == window.recipeListId ? 'recipe' : 'blog';
                if(!articlesData) return;
                let levelIcon = '';
                if(articlesData?.level == 'Easy') {
                    levelIcon = this.settings.swym_recipe_easy_icon;
                } else if(articlesData?.level == 'Moderate') {
                    levelIcon = this.settings.swym_recipe_moderate_icon;
                } else if(articlesData?.level == 'Advanced') {
                    levelIcon = this.settings.swym_recipe_advanced_icon;
                }
                articleMarkup += `
                    <dynamic-card data-url="${article.du}" data-lid="${article.lid}" data-epi="${article.epi}" data-empi="${article.empi}" data-du="${article.du}" class="swymcs-product-card" view="article-card"m article-type="${type}">
                        <a href="${article.du}" class="!relative grid gap-xs items-center " data-cnstrc-item-name="${articlesData?.title}" data-cnstrc-item-id="${article.id}">
                            <button data-article-type="${articleType}" data-list-type="${type}" data-lid="${article.lid}" data-purpose="delete" data-epi="${article.epi}" data-empi="${article.empi}" data-du="${article.du}" class="swymcs-has-after-css ${this.isShareWishlistPage && 'swym-hide-container'} !bg-p-lightest !text-t-foreground !top-2 !right-2 !absolute !size-[1.625rem] !rounded-full !flex !items-center !justify-center swymcs-button swymcs-product-delete-btn" aria-label="Delete ${article.title}">
                                <span class="swym-icon">${this.settings.swym_delete_list_icon}</span>
                            </button>
                            <div class="relative aspect-square w-full overflow-clip ">
                                ${articlesData?.level != '' ? `
                                    <div class="absolute z-10 top-xs left-xs p-2xs flex items-center justify-center gap-2xs bg-t-background ">
                                        ${levelIcon != '' ? `<img src="${levelIcon}" loading="lazy" class="w-full block size-full object-contain" fetchpriority="auto">` : ``} 
                                        <span class="text-[0.688rem] text-body ">${articlesData?.level}</span>
                                    </div>` : ``}
                                <img src="${articlesData?.image}" alt="${articlesData?.title}" loading="lazy" class="w-full block size-full object-cover" fetchpriority="auto"/>
                            </div>
                            <div class="w-full flex flex-col gap-2xs overflow-hidden">
                                <p class="text-t-foreground-secondary caption uppercase">
                                    ${articlesData?.subtitle}
                                </p>
                                <h6 class="h6 line-clamp-2 leading-[1.2rem] font-medium">${articlesData?.title}</h6>
                                <div class="text-caption line-clamp-3 text-t-foreground-secondary">${articlesData?.excerpt}</div>
                            </div>
                        </a>
                    </dynamic-card>
                `;
            });
            this.productsContainer.innerHTML = articleMarkup;
            this.productsContainer.classList.remove('swymcs-empty-list');
            this._scrollToTop();
        }

        _renderEmptySFLList(){
            this.productsContainer.classList.add('swymcs-empty-list');
            this.productsContainer.innerHTML = window.emptySFLListContent;
            this.productsContainer.querySelector('#swym-empty-sfl-list-container').classList.remove('swym-hide-container');
        }

        _renderEmptyList(){
            this.productsContainer.classList.add('swymcs-empty-list');
            this.productsContainer.innerHTML = window.emptyListContent;
            this.productsContainer.querySelector('#swym-empty-wishlist-container').classList.remove('swym-hide-container');
        }

        async _renderShareListPopup(evt){
            this._closeAdditionalOptionsPopup();
            this._renderShareList();
        }

        async _renderAdditionalOptionsPopup (evt) {
            const page = document.querySelector('swym-wishlist-page');
            const target = evt.target;
            if(target.id == 'swymcs-additional-options') return; 
            page._hidePopupContainer(page.querySelector('.swym-active-popup'));
            const action = target.dataset.action; 
            page._closeAdditionalOptionsPopup();
            if(action == 'share') page._renderShareList();
            else if(action == 'rename') page._renderRenameList();
            else if(action == 'duplicate') page._renderDuplicateList();
            else if(action == 'delete') page._renderDeleteList();
        }

        _closeAdditionalOptionsPopup () {
            this._hideContainer(this.shareListPopup);
            this._hideContainer(this.renameListPopup);
            this._hideContainer(this.duplicateListPopup);
            this._hideContainer(this.deleteListPopup);
            this._hidePopupContainer(this.additionalOptionsPopupContainer);
        }

        async _renderShareList() {
            if(!window.isLoggedIn) {
                this._hidePopupContainer(this.additionalOptionsContainer);
                this._showPopupContainer(this.accountPopup);
                return;
            }

            const list = this.lists.find(list => list.lid == window.currentActiveListId);
            const shareableLink = await this._prepareShareLink(list);
            this.shareLinkField.textContent = shareableLink;
            
            !this.isShareEnabledUsingSocialMedia && this._hideContainer(this.additionalShareButtonsContainer);
            this._showContainer(this.shareListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
            await this._markListAsPublic();
        }

        _markListAsPublic(){
            console.log('list marked as public');    
            return new Promise(async (resolve, reject) => {
                this.swat.markListPublic(window.currentActiveListId,
                    list => resolve(list),
                    err => reject(err)
                );
            });
        }

        _renderRenameList () {
            this.renameListName.textContent = this.activeListTilte.textContent;
            this.renameListTextField.value = this.activeListTilte.textContent;
            this.renameListTextField.placeholder = this.activeListTilte.textContent;
            this._showContainer(this.renameListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderDuplicateList () {
            this.duplicateListName.textContent = this.activeListTilte.textContent;
            this.duplicateListTextField.value = 'Copy Of ' + this.activeListTilte.textContent;
            this.duplicateListTextField.placeholder = this.activeListTilte.textContent;
            this._showContainer(this.duplicateListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderDeleteList () {
            this.deleteListName.textContent = this.activeListTilte.textContent;
            this._showContainer(this.deleteListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        /* Show / Hide containers */

        _overlayEvent(evt){
            if (evt.target.nodeName == 'BODY') {
                this.querySelectorAll(".swym-active-popup").forEach(popup => this._hidePopupContainer(popup));
              }
        }

        _scrollToTop () {
            const header = document.querySelector('.swymcs-page-header');
            if (header) {
                var targetOffsetTop = header.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: targetOffsetTop,
                    behavior: "smooth"
                });
            }
        }

        _showPopupContainer (selector) {
            selector.classList.remove('swym-hide-container');
            selector.classList.add('swym-active-popup');
            this.body.classList.add('no-scroll');
        }

        _hidePopupContainer (selector) {
            selector.classList.add('swym-hide-container');
            selector.classList.remove('swym-active-popup');
            this.body.classList.remove('no-scroll');
        }

        _showContainer (selector) {
            selector.classList.remove('swym-hide-container');
        }

        _hideContainer (selector) {
            selector.classList.add('swym-hide-container');
        } 

        /* Javascript APIs related functions */
        _getLists () {
            return new Promise(async (resolve, reject) => {
                this.swat.fetchLists({
                  callbackFn: lists => resolve(lists),
                  errorFn: err => reject(err)
                });
            });
        } 

        _getListDetails(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListDetails(
                  { lid: lid },
                  list => resolve(list),
                  error => reject(error)
                );
            });
        }

        async _getCompleteListDetails(){
            const lists = await this._getLists();
            if(!lists.length) return lists;

            const productList = lists.find(list => list.lid == window.productListId);
            const recipeList = lists.find(list => list.lid == window.recipeListId);
            const blogList = lists.find(list => list.lid == window.blogListId);
            const updatedLists = [productList, recipeList, blogList];
            
            // Load only first 3 products for each list for preview
            await Promise.all(updatedLists.map(async list => {
                if(list.lid == window.productListId) {
                    const products = await this._getProductsFromList(list.lid);
                    list.listcontents = products.slice(0, 3); // Only get first 3 products for preview
                    list.listcontents = await this._getShopifyProductsData(list.listcontents);
                    if(products.length <= 3) list.allProductsLoaded = true;
                    list.totalProducts = products.length;
                }
            }));
            return updatedLists;
        }

        _getProductsFromList(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListCtx(
                  { lid: lid },
                  listContents => resolve(listContents),
                  error => reject(error)
                );
            });
        }
      
       async _getShopifyProductsData(products){
            if(!products.length) return []; 
            const section = this;   
            let buggedProductsArray = []; 
            let res = await Promise.all(products.map(async (pdp) => {
                try {
                    const productHandleString = pdp.du.split('/products/')[1];
                    const productHandle = productHandleString.split('?')[0];
                    const reqURL = `/products/${productHandle}`;
                    const productData = await fetch(`${reqURL}.js`);
                    const jsonData = await productData.json();
                    pdp.productData = jsonData;
                    return pdp;
                }
                catch(error){
                    const errorObj = {}; 
                    errorObj[pdp.du] = error; 
                    buggedProductsArray.push(errorObj);
                    return null; 
                }
            }));

            console.log('Products with bugs - ', buggedProductsArray);
            res = res.filter(product => product && product.productData);
            return res;
        }

        _setListProperties(list, listContents, allProductsLoaded = false) {
            list.listcontents = listContents;
            list.totalProducts = listContents.length;
            list.allProductsLoaded = allProductsLoaded;
            return list;
        }

        _deleteProductFromList(product, lid, parentNode, listType){
            const onSuccessWishlist = async deletedProduct => {
                parentNode.remove();
                if(!this.productsContainer.querySelector('.swymcs-product-card')){
                    this._renderProductsGrid([]);
                }
                if(this.isSingleList) {
                    this.list.listcontents = this.list.listcontents.filter(product => product.epi !== deletedProduct.epi);
                    this.list = this._setListProperties(this.list, this.list.listcontents, true);
                    this._renderSingleListHeader(lid);
                } else {
                    this.lists = this.lists.map(list => {
                        if (list.lid === lid) {
                            const updatedListContents = list.listcontents.filter(product => product.epi !== deletedProduct.epi);
                            return this._setListProperties({...list}, updatedListContents, true);
                        }
                        return list;
                    });
                    this._renderListHeader(lid); 
                }
            }

            const onSuccessSFL = async response => {
                const deletedProduct = response.itemsdeleted[0];
                parentNode.remove();
                if(!this.productsContainer.querySelector('.swymcs-product-card')){
                    this._renderProductsGrid([], 'sfl');
                }
                this.sflList.listcontents = this.sflList.listcontents.filter(product => product.epi !== deletedProduct.epi);
            }
            const onError = error => console.log("Error while deleting the Product", error)
            if(listType == 'wishlist') this.swat.deleteFromList(lid, product, onSuccessWishlist, onError);
            else if(listType == 'sfl') this.swat.SaveForLater.remove(lid, [product], onSuccessSFL, onError);
        }

        _deleteArticleFromList(article, lid, parentNode, articleType){
            const onSuccess = async deletedArticle => {
                parentNode.remove();
                if(!this.productsContainer.querySelector('.swymcs-product-card')){
                    this._renderProductsGrid([]);
                }
                if(articleType == 'recipe'){
                    this.recipeListProducts = this.recipeListProducts.filter(article => article.epi !== deletedArticle.epi);
                } else if(articleType == 'blog'){
                    this.blogListProducts = this.blogListProducts.filter(article => article.epi !== deletedArticle.epi);
                }
                this._renderArticlesHeader(articleType);
            }
            const onError = error => console.log("Error while deleting the Article", error)
            this.swat.deleteFromList(lid, article, onSuccess, onError);
        }

        _renameList(){
            const listName = this.renameListTextField.value; 
            const isValidListName = this._validateListName(listName.trim().toLowerCase(), this.renameListError);
            if(!isValidListName) return;
            const listUpdateConfig = {
                "lid": window.currentActiveListId,
                "lname": listName,
            };
            const onSuccess = async (updatedListObj) => {
                this._closeAdditionalOptionsPopup();
                const listcontents = this.lists.find(list => list.lid === updatedListObj.lid).listcontents;
                this.lists = this.lists.map(list => list.lid === updatedListObj.lid ? this._setListProperties(updatedListObj, listcontents, true) : list);
                this._renderListHeader(window.currentActiveListId);
            }
            const onError = error => console.log(`Error while Renaming the List, ${window.currentActiveListId}`, error);
            _swat.updateList(listUpdateConfig, onSuccess, onError);
        }

        _duplicateList(){
            const listName = this.duplicateListTextField.value; 
            const isValidListName = this._validateListName(listName.trim().toLowerCase(), this.duplicateListError);
            if(!isValidListName) return;
            const listConfig = {
                "lname": listName,
                "fromlid": window.currentActiveListId,
            };
            const onSuccess = async (listObj) => {
                const listContents = this.lists.find(list => list.lid === window.currentActiveListId).listcontents;
                this.lists.unshift(this._setListProperties(listObj, listContents, true));
                this._hideContainer(this.listProductsContainer);
                this._renderListProducts(listObj.lid);
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => console.log(`Error while duplicating the List, ${lid}`, error);
            _swat.createList(listConfig, onSuccess, onError);
        }

        _deleteList(){
            const onSuccess = deletedListObj => {
                this._closeAdditionalOptionsPopup();
                this.lists = this.lists.filter(list => list.lid != window.currentActiveListId);
                this._hideContainer(this.listProductsContainer);
                this._showContainer(this.pageLoader);
                if(this.isSingleList) {
                    this.list = null;
                }
                this.isSingleList ? this._renderSingleList() : this._renderMultipleList();
            }
            const onError = error => console.log(`Error while deleting the List, ${lid}`, error);
            _swat.deleteList(window.currentActiveListId, onSuccess, onError);
        }

        _validateListName(name, errorField){
            const isValidList = false;
            if(name.length < 3){
                errorField.textContent = 'Name must be longer than 3 characters';
                return isValidList; 
            }
            const lists = this.lists;
            const matchedList = lists.find(list => list.lname.trim().toLowerCase() == name);
            if(matchedList) {
                errorField.textContent = 'List name already exists';
                return isValidList;
            }
            errorField.textContent = '';
            return !isValidList;
        }

        _validateEmail() {
            const emailPattern = /^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/;
            const isBlank = this.shareEmailField.value=='' ? true : false;
            const isInvalidString = !this.shareEmailField.value.match(emailPattern) ? true : false;
            if(isBlank || isInvalidString){
                this.shareListError.textContent = isBlank ? 'Please enter the email address' : 'Please enter a valid email address';
                return false;
            }
            this.shareListError.textContent = '';
            return true;
        }

        _addProductToCart(button){
            const epi = +button.dataset.epi;
            const empi = +button.dataset.empi;
            const du = button.dataset.du;
            this.swat.replayAddToCart({
                empi,
                du,
                qty: 1
            }, epi, (c) => {
                button.classList.add('swymcs-product-in-cart');
                button.textContent = 'Added to cart'; 
                document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            }, (error) => {
                button.textContent = 'Add to cart';
                _swat.ui.uiRef.showErrorNotification({ message: error.description });
            }); 
        }

        async _addAllProductToCart(evt) {
            const page = this;
            try {
                const productsData = [...page.querySelectorAll('.swymcs-product-card .swymcs-add-to-cart-btn:not(:disabled)')].map(container => ({
                    id: +container.dataset.epi,
                    quantity: 1
                }));
                let formData = { 'items': productsData };
        
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData)
                });
        
                const cartResponse = await response.json();
                cartResponse.items.forEach(item => {
                    const variantId = item.id;
                    const button = page.querySelector(`.swymcs-add-to-cart-btn[data-epi="${variantId}"]`);
                    button.textContent = 'Added to cart';
                });
                evt.target.textContent = 'Added to cart';
                this._scrollToTop();
                document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            } catch (error) {
                _swat.ui.uiRef.showErrorNotification({ message: error.description });
                console.error('Error:', error);
            }
        }

        _prepareShareLink(list){
            return new Promise(async (resolve, reject) => {
                this.swat.generateSharedListURL(list.lid,
                    (link, lid) => resolve(link, lid),
                    err => reject(err)
                );
            });
        }

        _shareListByCopy(evt){
            const page = this;
            const button = evt.currentTarget;
            navigator.clipboard.writeText(this.shareLinkField.textContent)
            .then(() => {
                button.querySelector('.swymcs-share-button-text').textContent = 'Copied';
                setTimeout(() => {
                    button.querySelector('.swymcs-share-button-text').textContent = page.settings.swym_share_copy_btn_text;
                }, 3000);
            })
            .catch(error => _swat.ui.uiRef.showErrorNotification({message: error.description}));
        }

        _shareListByEmail(){
            const email = this._validateEmail();
            if(!email) return;
            const onSuccess = response => {
                _swat.ui.uiRef.showSuccessNotification({message: 'List shared successfully over mail'});
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: error.description});
            _swat.sendListViaEmail({
                'toEmailId': this.shareEmailField.value.trim(),
                'note': this.shareMessageField.value,
                'fromName': this.shareNameField.value,
                'lid': window.currentActiveListId,
            }, onSuccess, onError);
        }

        _shareListOnPlatform(platform){
            const shareUrl = this.shareLinkField.textContent;
            const note = this.shareMessageField.value;
            const fromName = this.shareNameField.value;
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: error.description});
            let platformShareUrlTemplate = '';
            if(platform == 'facebook') 
                platformShareUrlTemplate = `https://www.facebook.com/sharer.php?u=${shareUrl}&t=${note}`;
            else if(platform == 'twitter')  
                platformShareUrlTemplate = `https://twitter.com/share?text=${note}&url=${shareUrl}`; 
            _swat.shareListSocial(window.currentActiveListId, fromName, platformShareUrlTemplate, platform, note, onError)
        }

        async _renderSFLContents(){
            if(!this.isSFLEnabled || this.isShareWishlistPage) return;
            this.sflList = await this._getSflList();
            window.saveForLaterListId = this.sflList.listid;
            const sflProducts = await this._getSflProducts();
            this.sflList.listcontents = await this._getShopifyProductsData(sflProducts);
            this._showContainer(this.pageTitleSFLTab);
        }

        _getSflList() {
            return new Promise(async (resolve, reject) => {
                this.swat.SaveForLater.init(
                    (list) => resolve(list),
                    (error) => reject(error)
                );
            });
        }

        async _getSflProducts(){
            return new Promise(async (resolve, reject) => {
                this.swat.SaveForLater.fetch(
                  window.saveForLaterListId,
                  (products) => resolve(products.items),
                  (error) => reject(error)
                );
            });
        }

        async _renderSFLContainer(){
            this._hideContainer(this.listsContainer);
            this._hideContainer(this.wishlistHeader);
            this._hideContainer(this.backToListView);
            this._hideContainer(this.emptyListContainer);
            this._hideContainer(this.emptySFLListContainer);
            this._showContainer(this.wishlistContainer);
            this._showContainer(this.listProductsContainer);
            this._renderProductsGrid(this.sflList.listcontents, "sfl");
        }

        async _renderArticlesContainer(type){
            this._renderArticlesHeader(type);
            this._hideContainer(this.listsContainer);
            this._showContainer(this.wishlistHeader);
            this._hideContainer(this.backToListView);
            this._hideContainer(this.emptyListContainer);
            this._hideContainer(this.emptySFLListContainer);
            this._showContainer(this.wishlistContainer);
            this._showContainer(this.listProductsContainer);
            const articlesData = type == 'recipe' ? this.recipeListProducts : this.blogListProducts;
            this._renderArticlesGrid(articlesData);
        }

        /* Header functions */

        _loginButtonAction(evt){
            const redirectionUrl = evt.currentTarget.getAttribute('data-redirection-url');
            const actionUrl = evt.currentTarget.getAttribute('data-action-url');
            localStorage.setItem('SWYM_REDIRECT_URL', redirectionUrl);
            localStorage.setItem('SWYM_ACTION_URL', actionUrl);
            location.href = actionUrl;
        }

        async _switchListsFromHeader (evt){
            const page = document.querySelector('swym-wishlist-page');
            const lid = evt.target.dataset.lid;
            page._hideContainer(page.listProductsContainer);
            page._renderListHeader(window.currentActiveListId);
            page._renderListProducts(lid);
            page._hidePopupContainer(page.headerListsContainer);
        }

        _toggleListView(evt){
            if(!this.isSFLEnabled || this.isShareWishlistPage) return;
            const target = evt.target;
            if(target.classList.contains('swymcs-active-tab') && !target.classList.contains('swymcs-page-title')) return;
            this.pageTitleTabContainer.querySelectorAll('.swymcs-page-title').forEach(tab => tab.classList.remove('swymcs-active-tab'));
            target.classList.add('swymcs-active-tab');
            switch(target.dataset.type){
                case 'wishlist':
                    this._renderSingleList()
                    break;
                case 'sfl':
                    this._renderSFLContainer();
                    break;
                case 'recipe':
                    this._renderArticlesContainer('recipe');
                    break;
                case 'blog':
                    this._renderArticlesContainer('blog');
                    break;
                default:
                    console.error('Invalid list type');
                    break;
            }
        }

        /* Product Grid Events */
        
        async _eventsForProductsGrid (evt) {
            const target = evt.target;
            const page = document.querySelector('swym-wishlist-page');
            const purpose = target.dataset?.purpose;
            if(!purpose) return; 
            evt.preventDefault();
            if(purpose == 'cart') page._addProductToCart(target);
            else if (purpose == 'delete'){
                if(target.hasAttribute('data-article-type')) {
                    const articleType = target.getAttribute('data-article-type');
                    page._deleteArticleFromList({
                        "epi": target.dataset.epi,
                        "empi": target.dataset.empi,
                        "du": target.dataset.du
                    }, target.dataset.lid, target.closest('.swymcs-product-card'), articleType);
                } else {
                    page._deleteProductFromList(
                        {
                            "epi": target.dataset.epi,
                            "empi": target.dataset.empi,
                            "du": target.dataset.du
                        }, target.dataset.lid, target.closest('.swymcs-product-card'), target.dataset.listType
                    );
                }
            }
        }

        _selectProductSize(evt){
            const target = evt.target;
            evt.preventDefault();
            const selectedOption = target.options[target.selectedIndex];
            const productCard = target.closest(".swymcs-product-card");
            const addToCartButton = productCard.querySelector('button[data-purpose="cart"]');
            const priceContainer = productCard.querySelector('span.text-utility-regular');
            addToCartButton.innerText = selectedOption.dataset.available === "true" ? (selectedOption.dataset.incart === "true" ? `${this.settings.added_to_cart_text}` : `${this.settings.add_to_cart_text}`) : `${this.settings.sold_out_text}`;
            addToCartButton.dataset.epi = selectedOption.value;
            addToCartButton.disabled = selectedOption.dataset.available === "false";
            priceContainer.textContent = `${window.currencyCode}${parseFloat(selectedOption.dataset.variantCost).toFixed(2)}`;
        }

        /* Additional Options */
    }
    customElements.define('swym-wishlist-page', SwymWishlistPage);
}